import { SWRConfiguration } from 'swr';

import { getEmploymentData } from '~/data/employee';
import { useArraySWR } from '~/hooks/useSWR';

export const useEmploymentData = (
  props: { employeeId: number },
  swrConfig?: SWRConfiguration,
) => {
  const { employeeId } = props;
  return useArraySWR(
    ['employmentData', employeeId],
    ([_key, employeeId]) => getEmploymentData(employeeId),
    swrConfig,
  );
};
